import React from 'react';
import Form from 'react-bootstrap/Form';
import CreatableSelect from 'react-select';
import {FormikProps} from 'formik';
import i18n from 'i18n';
import FormHelp from '@/components/forms/FormHelp';

interface EmailOption {
    value: string;
    label: string;
}

interface FormValues {
    params: {
        emailArray: string[];
    };
    emailSelectInputValue: string;
    touched?: {
        params?: {
            emailArray?: boolean[];
        };
    };
    errors?: {
        params?: {
            emailArray?: string[];
        };
    };
}

interface ActionSendEmailFormFieldsProps {
    formik: FormikProps<FormValues>;
    addEmail: (formik: FormikProps<FormValues>, email: string) => void;
}

const ActionSendEmailFormFields: React.FC<ActionSendEmailFormFieldsProps> = React.memo((
    {
        formik,
        addEmail,
    },
) => {

    return (
        <Form.Group className="mb-3" controlId="params.emailArray" >
            <Form.Label>
                {i18n.t('jt_email_addresses.text')}
                <FormHelp content={i18n.t('tt_insert_email.text')} placement="top" />
            </Form.Label>
            <CreatableSelect<EmailOption, true>
                inputValue={formik.values.emailSelectInputValue}
                value={formik.values.params.emailArray.map((x) => ({
                    value: x,
                    label: x,
                }))}
                isMulti
                name="params.emailArray"
                placeholder={i18n.t('es_insert_email.text')}
                onChange={(value) => {
                    if (!value) {
                        formik.setFieldValue('params.emailArray', []);
                    } else {
                        const emailOptions = Array.isArray(value) ? value : [value];
                        formik.setFieldValue('params.emailArray', emailOptions.map((x: EmailOption) => x.value));
                    }
                }}
                onBlur={(event) => {
                    addEmail(formik, formik.values.emailSelectInputValue);
                    formik.handleBlur(event);
                }}
                menuIsOpen={false}
                components={{
                    DropdownIndicator: null,
                }}
                styles={{
                    control: (provided) => {
                        const touchedArray = formik.touched.params?.emailArray;
                        const errorArray = formik.errors.params?.emailArray;

                        if (
                            touchedArray && Array.isArray(touchedArray) && touchedArray.some(Boolean)
                            && errorArray && Array.isArray(errorArray) && errorArray.length > 0
                        ) {
                            return {
                                ...provided,
                                border: '1px solid #dc3545',
                            };
                        }

                        return provided;
                    },
                }}
                onInputChange={(value) => {
                    if (value && ',; '.includes(value.slice(value.length - 1))) {
                        addEmail(formik, value.slice(0, value.length - 1));
                    } else {
                        formik.setFieldValue('emailSelectInputValue', value);
                    }
                }}
                onKeyDown={(event) => {
                    if (['Tab', 'Enter'].includes(event.key)) {
                        addEmail(formik, formik.values.emailSelectInputValue);
                        event.preventDefault();
                    }
                }}
                className="action-settings-emails"
            />
            <Form.Control.Feedback
                type="invalid"
                style={{display: 'block'}}
            >
                {formik.errors.params?.emailArray}
            </Form.Control.Feedback>
        </Form.Group >
    );
});

export default ActionSendEmailFormFields; 